import React, { createContext, useContext, useState, useEffect } from 'react';
import { Button, Checkbox, Modal, ModalBody, ModalFooter, ModalTitle, ModalHeader } from 'adp-react-components';

const ExperimentalFeaturesContext = createContext({});

export const useExperimentalFeaturesState = () => useContext(ExperimentalFeaturesContext);

export const ExperimentalFeaturesProvider = ({ children }) => {
    const [features, setFeatures] = useState({});

    const toggler = newFeature => setFeatures({ ...features, ...newFeature });

    return (
        <ExperimentalFeaturesContext.Provider value={{ features, toggler }}>
            {children}
        </ExperimentalFeaturesContext.Provider>
    );
};

export const ExperimentalFeaturesPanel = () => {
    const { features = {}, toggler } = useExperimentalFeaturesState();
    const [openModal, setOpenModal] = useState(false);
    const [toggles, setToggles] = useState([]);

    useEffect(() => {
        if (openModal) {
            const featureList = Object.keys(features).map(key => ({ name: key, status: features[key] }));
            setToggles(featureList);
        }
    }, [openModal, features]);

    return (
        <div style={{ margin: 'auto', visibility: Object.keys(features).length > 0 ? 'visible' : 'hidden' }}>
            <Button onClick={() => setOpenModal(true)}>Experimental Features</Button>
            <Modal show={openModal} size="sm" backdrop={true} closeable="true" animation={true} onHide={() => setOpenModal(false)}>
                <ModalHeader closeButton={true}>
                    <ModalTitle>Experimental Features Panel</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    {toggles.map((toggle, i) => (<div key={`toggle-${i}`} style={{ display: 'flex', padding: '20px' }}>
                        <Checkbox checked={toggle.status} onChange={() => toggler({ [toggle.name]: !toggle.status })} />
                        <span>{toggle.name}</span>
                    </div>))}
                </ModalBody>
                <ModalFooter>
                    <Button onClick={() => setOpenModal(false)} buttonStyle="primary">CLOSE</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};
